import React, { useState } from 'react';

export default function SpotifyPlayer() {
  const [showPlaylist, setShowPlaylist] = useState(false);
  const playlistUrl = "https://open.spotify.com/playlist/4ZYlpVzu1XJcy7cHqoozSE";

  return (
    <div>
      <h2>Remember 'Jam Night'? 🎵</h2>
      <button
        className="btn-primary"
        onClick={() => setShowPlaylist(prev => !prev)}
        style={{ marginBottom: '20px' }}
      >
        {showPlaylist ? 'Hide Playlist' : 'Show Playlist'}
      </button>

      {showPlaylist && (
        <iframe
          src={playlistUrl.replace('playlist', 'embed/playlist')}
          width="100%"
          height="380"
          frameBorder="0"
          allow="encrypted-media"
          style={{ borderRadius: '16px', boxShadow: '0 10px 30px rgba(0,0,0,0.15)' }}
          title="Toto's Spotify Playlist"
        />
      )}
    </div>
  );
}
